<template>
    <div>
        <el-dialog :visible.sync="inWarehouseDialog" width="20%" top="13vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog" :show-close = false>
             <el-form ref="form" :model="request" label-position="center">
                <el-form-item label="入库仓库" required>
                    <el-select v-model="request.warehouseId" placeholder="入库仓库" style="width:200px">
                        <el-option v-for="item in response.data" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备类型" required>
                    <el-select v-model="request.deviceType" placeholder="设备类型" style="width:200px">
                        <el-option v-for="item in deviceCategory" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item required>
                    <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;供应商</label>
                    <el-select v-model="request.deviceSupplier" placeholder="供应商" style="width:200px" @change="chooseSupplier">
                        <el-option v-for="item in dict.device_supplier" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择文件" required>
                    <el-upload class="upload" ref="upload" accept=".xlsx, .xls" action="#" :http-request="uploadHttpRequest" :file-list="fileList" :limit="limitNum" :auto-upload="false" :on-change="handleChange"
                               :on-exceed="onExceed" :on-remove="onRemove" style="float:left;">
                        <el-button size="small" type="warning" plain  style="width:200px">excel导入</el-button>
                    </el-upload>
                    <div style="float:left;margin-left: 5px">
                        
                        <span v-if="response.deviceIds > 0">设备数量：{{response.deviceIds}}</span>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button style="background-color:#A9F5F2;margin: 0" @click="inWarehouseDialog = false">取消</el-button>
                <el-button type="warning" style="margin: 0" plain @click="submitUpload">上传</el-button>
                <el-button style="background-color:#A9F5A9;margin: 0" @click="inWarehouse">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {getAllWarehouse, excelUpload, inWarehouse} from "../../../api/warehousedevice/warehousedevice.js";
import { formatDate } from "../../../utils/date.js";
export default {
    data() {
        return {
            inWarehouseDialog: false,
            loading: false,
            request: {
                warehouseId: '',
                deviceType: '',
                deviceSupplier: '',
                deviceSupplierStr: '',
                deviceIds: []
            },
            response: {data: [], deviceIds: 0},
            global: '',
            dict: '',
            deviceCategory: [
                {
                    name: '充电柜主机',
                    value: 'power_box'
                },
                {
                    name: '充电柜从机',
                    value: 'power_box_slave'
                },
                {
                    name: '充电宝',
                    value: 'power_bank'
                }
            ],
            fileList: [],
            limitNum: 1,
            
            
        }
    },
    methods: {
        init(){
            this.inWarehouseDialog = true;
            this.global = JSON.parse(sessionStorage.getItem("global"));
            this.dict = JSON.parse(sessionStorage.getItem("dict"));
            getAllWarehouse().then(result=>{
                this.response.data = result.data;
            })
        },

        /**
         * 选择供应商
         */
        chooseSupplier(value){
            this.dict.device_supplier.forEach(item => {
                if(item.id === value){
                    this.request.deviceSupplierStr = item.name;
                }
            });
        },

        /**
         * excel上传
         */
        uploadHttpRequest() {
            if (this.fileList.length === 0) {
                this.$confirm('文件不能为空', '错误', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error',
                    center: true
                })
                this.loading = false;
                return;
            } else {
                const file = new FormData();
                this.fileList.forEach(item=>{
                    file.append("excelFile", item.raw);
                })
                excelUpload(file).then(result=>{
                    if(result.code === '000000'){
                        this.response.deviceIds = result.data.length;
                        this.request.deviceIds = result.data;
                        this.loading = false;
                    }else{
                        this.$message.error(result.message);
                    }
                    
                })
            }
        },

        /**
         * 提交上传
         */
        submitUpload(){
            this.$refs.upload.submit();
        },

        /**
         * 文件改变钩子
         */
        handleChange(file, fileList){
            this.fileList = fileList;
        },

        /**
         * 文件超出个数时钩子
         */
        onExceed(file,fileList){
            this.$message.error("已选择文件！");
        },

        /**
         * 文件移除钩子
         */
        onRemove(file,fileList){
            this.$refs.upload.clearFiles();
            this.response.deviceIds = 0;
            this.request.deviceIds = [];
        },

        /**
         * 入库
         */
        inWarehouse(){
            inWarehouse(this.request).then(result=>{
                if(result.code === '000000'){
                    this.$emit("in-succeed","入库成功");
                    this.$message({
                        message: "入库成功",
                        type: "success",
                        duration: 1500,
                    });
                }
            });
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.request.warehouseId = "";
            this.request.deviceSupplier = "";
            this.request.deviceSupplierStr = "";
            this.onRemove();
        }
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/warehouse/warehousedevice/inwarehouse.vue